import { useIntl } from 'react-intl'

import Text from 'app/components/base/Text'
import PaymentCards from 'app/components/common/PaymentCards'
import { PAYMENT_CARDS_STATUS } from 'app/utils/constants/status.constants'
import {
  isPaypalPaymentActive,
  isStripePaymentActive
} from 'app/utils/helpers/functions.helpers'

interface PaymentInfoProps {
  paymentGateways?: PaymentGatewayModel[]
}

const PaymentInfo: RFC<PaymentInfoProps> = ({ paymentGateways = [] }) => {
  const { formatMessage } = useIntl()
  const isStripe = isStripePaymentActive(paymentGateways)
  const isPaypal = isPaypalPaymentActive(paymentGateways)

  const hasPaymentMethod = isStripe || isPaypal
  const isBoth = isStripe && isPaypal
  const paymentMethod = isStripe
    ? PAYMENT_CARDS_STATUS.stripe
    : PAYMENT_CARDS_STATUS.paypal
  const currentPaymentMethod = isBoth
    ? PAYMENT_CARDS_STATUS.both
    : paymentMethod

  if (!hasPaymentMethod) {
    return (
      <Text variant="body2" color="text.third" sx={{ mb: 3 }}>
        {formatMessage({
          defaultMessage:
            'Please connect a payment method and the possible options will be displayed here.'
        })}
      </Text>
    )
  }

  return (
    <PaymentCards
      paymentMethod={currentPaymentMethod}
      title={formatMessage({
        defaultMessage: 'Accepted payment methods:'
      })}
    />
  )
}

export default PaymentInfo
